//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      watermark: {
        image: null,
        logo: null,
      },
    };
  },

  computed: {
    ...mapState('settingsWatermark', ['data']),

    getImageExtension() {
      if (this.data?.expectedImageExtension === 'svg') return 'svg+xml';
      return this.data?.expectedImageExtension ?? 'png';
    },

    getLogoExtension() {
      if (this.data?.expectedLogoExtension === 'svg') return 'svg+xml';
      return this.data?.expectedLogoExtension ?? 'png';
    },

    getLogoSource() {
      return this.data?.logo;
    },

    getImageSource() {
      return this.data?.image;
    },

    isImageEnabled() {
      return this.data?.isImageEnabled ?? false;
    },

    isLogoEnabled() {
      return this.data?.isLogoEnabled ?? false;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('settingsWatermark', [
      'loadData',
      'uploadImage',
      'uploadLogo',
    ]),

    async setWatermarkImage() {
      const formData = new FormData();
      formData.append('file', this.watermark.image);
      this.setGeneralLoader(true);
      try {
        await this.uploadImage(formData);
        await this.loadData();
        this.setSuccessNotification('Watermark image uploaded');
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.watermark.image = null;
      this.setGeneralLoader(false);
    },

    async setWatermarkLogo() {
      const formData = new FormData();
      formData.append('file', this.watermark.logo);
      this.setGeneralLoader(true);
      try {
        await this.uploadLogo(formData);
        await this.loadData();
        this.setSuccessNotification('Watermark logo uploaded');
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.watermark.logo = null;
      this.setGeneralLoader(false);
    },
  },
};
